import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import {CmsConfig, provideConfig, provideDefaultConfig} from '@spartacus/core';
import { UigNavigationModule } from '../uig-navigation/uig-navigation.module';
import { UigCategoryNavigationComponent } from './uig-category-navigation.component';

@NgModule({
    imports: [CommonModule, UigNavigationModule],
    providers: [
        provideConfig(<CmsConfig>{
            cmsComponents: {
                CategoryNavigationComponent: {
                    component: UigCategoryNavigationComponent,
                },
            },
        }),
    ],
    declarations: [UigCategoryNavigationComponent],
    exports: [UigCategoryNavigationComponent]
})
export class UigCategoryNavigationModule {}
